export default function toCamelCase (str) {
	return str.replace(/-([a-z])/gi, function (_, $1) { return $1.toUpperCase(); });
}
